// English UI strings. Keys are shared by every language file; `{name}` is interpolated.
export const en = {
  'app.name': 'Edil',
  'app.tagline': 'Timed Pool Raffle',
  'nav.lobby': 'Rooms',
  'nav.raffle': 'Raffle',
  'nav.bingo': 'Bingo',
  'nav.tickets': 'My tickets',
  'nav.wallet': 'Wallet',
  'nav.profile': 'Profile',
  'common.loading': 'Loading…',
  'common.retry': 'Try again',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.save': 'Save',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.offline': 'You are offline. Showing the last data we had.',
  'common.live_paused': 'Live updates paused; refreshing every 5 seconds.',
  'auth.sign_in': 'Sign in',
  'auth.sign_out': 'Sign out',
  'auth.register': 'Create account',
  'auth.phone': 'Phone number',
  'auth.password': 'Password',
  'auth.display_name': 'Your name',
  'auth.dob': 'Date of birth',
  'auth.confirm_age': 'I am at least {age} years old',
  'auth.accept_terms': 'I accept the terms and the responsible gaming rules',
  'auth.no_account': 'New to Edil?',
  'auth.have_account': 'Already have an account?',
  'auth.with_telegram': 'Continue with Telegram',
  'auth.forgot': 'Forgot password?',
  'auth.reset_sent': 'If this number has a linked Telegram account, we sent a reset link there.',
  'auth.reset_title': 'Choose a new password',
  'auth.reset_done': 'Password changed. Please sign in.',
  'auth.new_password': 'New password',
  'auth.sign_in_to_play': 'Sign in to buy tickets',
  'lobby.title': 'Rooms',
  'lobby.draw_in': 'Draw in',
  'lobby.sold': '{sold} of {board} sold',
  'lobby.first_prize': '1st prize',
  'lobby.your_tickets': '{count} yours',
  'lobby.no_round': 'Next round opens soon',
  'lobby.winners': 'Recent winners',
  'lobby.winner_line': '{name} won {amount} in {room}',
  'room.pick': 'Pick your numbers',
  'room.lucky_dip': 'Lucky dip',
  'room.basket': 'Your picks',
  'room.clear': 'Clear',
  'room.buy': 'Buy {count} ticket(s)',
  'room.confirm_title': 'Confirm purchase',
  'room.total': 'Total',
  'room.balance_after': 'Balance after',
  'room.bought': 'Good luck! You have {count} new ticket(s).',
  'room.cap': 'Up to {max} tickets per player',
  'room.taken': 'Taken',
  'room.mine': 'Yours',
  'room.sales_closed': 'Sales closed. Drawing soon…',
  'room.prizes': 'Prizes now',
  'room.chance': 'Chance a ticket wins a prize: {pct}',
  'room.min_note': 'Needs {min} tickets to draw, otherwise every ticket is refunded.',
  'room.house': 'Edil House',
  'room.house_fill_note': 'This round draws even if few people play: once {fill} ticket(s) are sold, Edil House buys the rest up to {min}.',
  'room.house_fill_rule': 'If players buy at least {fill} but fewer than {min} tickets, Edil House buys the remaining tickets so the draw always happens. House tickets are marked on the board, and anything they win goes back to the house. Your chance per ticket is the same as in a full room.',
  'room.house_fill_rule_named': "If players buy at least {fill} but fewer than {min} tickets, Edil House buys the remaining tickets so the draw always happens. House tickets look like other players' tickets here; the verify page lists them, and anything they win goes back to the house.",
  'room.rules': 'Rules',
  'room.history': 'Past rounds',
  'room.add_money': 'Not enough balance. Add money',
  'round.state.SCHEDULED': 'Opens soon',
  'round.state.OPEN': 'Open',
  'round.state.CLOSED': 'Sales closed',
  'round.state.REFUNDING': 'Refunding',
  'round.state.REFUNDED': 'Refunded',
  'round.state.RESTARTED': 'Restarted',
  'round.state.DRAWING': 'Drawing',
  'round.state.DRAWN': 'Drawn',
  'round.state.SETTLING': 'Paying winners',
  'round.state.SETTLED': 'Finished',
  'round.drawing': 'Drawing the winners…',
  'round.results': 'Results',
  'round.place': '{place} place',
  'round.you_won': 'You won {amount}!',
  'round.refunded_note': 'Not enough tickets were sold, so every ticket was refunded.',
  'round.restarted_note': 'No tickets were sold in this round, so a new round started.',
  'round.verify': 'Verify this draw',
  'verify.title': 'Verify this round',
  'verify.intro': 'This page re-checks the draw in your browser. It does not trust the server.',
  'verify.house_numbers': 'Edil House tickets (house fill): {numbers}',
  'verify.commit': 'The revealed seed matches the commitment published before sales opened',
  'verify.tickets': 'The sold numbers match the record taken when sales closed',
  'verify.winners': 'Re-running the draw gives the same winners',
  'verify.ok': 'Verified: this draw was fair.',
  'verify.failed': 'Verification failed. Please message our support team: @EdilGamesSupport',
  'verify.pending': 'The seed is revealed after the draw. Come back then.',
  'tickets.title': 'My tickets',
  'tickets.empty': 'No tickets yet.',
  'tickets.status.ACTIVE': 'Waiting for draw',
  'tickets.status.WON': 'Won',
  'tickets.status.LOST': 'Not won',
  'tickets.status.REFUNDED': 'Refunded',
  'wallet.title': 'Wallet',
  'wallet.available': 'Available',
  'wallet.held': 'On hold',
  'wallet.history': 'History',
  'wallet.export': 'Download CSV',
  'wallet.add_money': 'Add money',
  'wallet.free_points': "Claim today’s free Edil Coins",
  'wallet.free_points_done': "Free Edil Coins added.",
  'wallet.points': "Edil Coins",
  'wallet.empty': 'No transactions yet.',
  'wallet.type.DEPOSIT': 'Deposit',
  'wallet.type.TICKET_PURCHASE': 'Tickets',
  'wallet.type.REFUND': 'Refund',
  'wallet.type.PRIZE': 'Prize',
  'wallet.type.FREEPLAY_GRANT': "Free Edil Coins",
  'wallet.type.WITHDRAWAL_HOLD': 'Withdrawal',
  'wallet.type.WITHDRAWAL_PAID': 'Withdrawal paid',
  'wallet.type.WITHDRAWAL_RELEASE': 'Withdrawal returned',
  'wallet.type.ADJUSTMENT': 'Adjustment',
  'wallet.type.REFERRAL_BONUS': 'Referral bonus',
  'wallet.type.SIGNUP_BONUS': 'Welcome bonus',
  'wallet.type.DEPOSIT_BONUS': "Deposit bonus",
  'wallet.type.BONUS_FORFEIT': "Bonus removed",
  'bonus.banner': 'Deposit bonus available · up to +{max}',
  'bonus.offer_title': "{pct}% deposit bonus up to {max}",
  'bonus.offer_title_tiers': "Deposit bonus up to {max}",
  'bonus.offer_first': "On your first deposit of {min} or more",
  'bonus.offer_any': "On your next deposit of {min} or more",
  'bonus.ends_in': "Ends in",
  'bonus.preview': "+{bonus} bonus: you play with {total}",
  'bonus.below_min': "Deposit at least {min} to get the bonus",
  'bonus.next_tier': "Add {more} more to get a {bonus} bonus",
  'bonus.terms': "Play {wager} in games within {days} days to unlock the bonus for withdrawal. Withdrawing earlier cancels the bonus.",
  'bonus.blocked.BONUS_ACTIVE': "Finish playing your current bonus to get this one.",
  'bonus.blocked.PHONE_NOT_VERIFIED': "Verify your phone number in Profile to get this bonus.",
  'bonus.on_approval': "+{bonus} bonus when your deposit is approved",
  'bonus.card_title': "Your bonus",
  'bonus.progress': "Played {wagered} of {required}",
  'bonus.expires': "Unlock it by {when}",
  'bonus.completed': "Unlocked: it is yours to withdraw",
  'bonus.withdraw_warning': "Your {bonus} bonus is still locked ({remaining} left to play). Withdrawing now cancels it.",
  'bonus.forfeit_confirm': "Cancel my bonus and withdraw",
  'bonus.cta': "Deposit now",
  'bonus.paid_badge': "+{bonus} bonus",
  'bonus.limited': "Limited offer: first come, first served",
  'bonus.missed.FIRST_DEPOSIT_ONLY': "This bonus is for first deposits only, and you have deposited before. You can still add money as usual.",
  'bonus.missed.LIMIT_REACHED': "You have already received this bonus. You can still add money as usual.",
  'bonus.missed.SOLD_OUT': "This bonus has run out: all places are taken. You can still add money as usual.",
  'bonus.missed.BUDGET_SPENT': "This bonus has run out. You can still add money as usual.",
  'bonus.missed.ENDED': "This bonus has ended. You can still add money as usual.",
  'bonus.missed.BONUS_ACTIVE': "Finish playing your current bonus to get this one.",
  'bonus.missed.PHONE_NOT_VERIFIED': "Verify your phone number in Profile to get this bonus.",
  'bonus.celebrate_title': "🎉 You're getting a {pct}% bonus!",
  'bonus.celebrate_title_plain': "🎉 You're getting a bonus!",
  'bonus.celebrate_sub': "Added when your deposit is approved: you play with {total}",
  'bonus.added_toast': "🎉 {bonus} bonus added to your wallet!",
  'invite.title': 'Invite friends',
  'invite.text': 'Share your link. Rewards are paid when a friend joins and meets the offer.',
  'invite.code': 'Your invite code',
  'invite.copy': 'Copy link',
  'invite.copied': 'Link copied.',
  'invite.share': 'Share',
  'invite.share_telegram': 'Share on Telegram',
  'invite.share_text': 'Join me on Edil: timed raffles with draws you can verify. 21+ only.',
  'invite.offer': 'You get {mine}. Your friend gets {theirs}. Paid {when}.',
  'invite.when_signup': 'when your friend signs up',
  'invite.when_deposit': 'after your friend deposits {amount} within {days} days',
  'invite.when_stake': 'after your friend plays {amount} within {days} days',
  'invite.when_verified': ' and verifies their phone',
  'invite.reward_none': 'nothing',
  'invite.reward_points': "{n} Edil Coins",
  'invite.reward_tickets': '{amount} in free tickets',
  'invite.reward_cash': '{amount} bonus cash',
  'invite.cash_note': 'Bonus cash must be played once before it can be withdrawn.',
  'invite.no_offer': 'There is no reward offer right now, but your link still counts your invites.',
  'invite.joined': 'Friends joined',
  'invite.pending': 'Waiting',
  'invite.rewarded': 'Rewarded',
  'invite.earned': 'You earned',
  'invite.earned_value': "{cash} and {points} Edil Coins",
  'auth.invite_code': 'Invite code (optional)',
  'auth.link_existing': 'Already have an Edil account from the website? Sign in instead and this Telegram account is linked to it.',
  'auth.invite_hint': 'From the friend or link that invited you.',
  'profile.title': 'Profile',
  'profile.language': 'Language',
  'profile.theme': 'Theme',
  'profile.theme_dark': 'Dark',
  'profile.theme_light': 'Light',
  'profile.theme_system': 'Match my device',
  'profile.support': "Help & support",
  'profile.support_text': "Questions, or a problem with a deposit, withdrawal or game? Our team answers on Telegram.",
  'profile.support_button': "Message {handle}",
  'profile.feed_opt_out': 'Hide my name in the winners list',
  'phone_verify.title': 'Verify your phone',
  'phone_verify.cta': 'Verify now',
  'phone_verify.later': 'Later',
  'profile.pin': 'PIN',
  'profile.pin_set': 'PIN is set',
  'profile.pin_new': 'New PIN (4–6 digits)',
  'profile.pin_current': 'Current PIN',
  'profile.payout': 'Payout accounts',
  'profile.payout_name': 'Name on the Telebirr account',
  'profile.payout_cooldown': 'Withdrawals resume {when}.',
  'profile.devices': 'Signed-in devices',
  'profile.this_device': 'This device',
  'profile.sign_out_device': 'Sign out',
  'profile.phone_unverified': 'Share your contact with the Edil bot on Telegram to verify your number.',
  'profile.saved': 'Saved.',
  'profile.link_first': 'To verify your number, first link your Telegram account to Edil.',
  'profile.link_this_telegram': 'Link this Telegram account',
  'profile.telegram_linked_done': 'Telegram linked. Now verify your number in the Edil bot.',
  'profile.verify_in_bot': 'Your Telegram is linked. Open the Edil bot, send /start and tap “Share phone number” to verify {phone}.',
  'profile.open_bot': 'Open the Edil bot',
  'phone.share_title': 'Share your phone number',
  'phone.share_body': 'Edil uses the number on your Telegram account, so it is verified straight away. It takes one tap.',
  'phone.share_button': 'Share phone number',
  'phone.waiting': 'Waiting for Telegram…',
  'phone.shared': 'Phone number added from Telegram',
  'phone.declined': 'You need to share your phone number to sign up here.',
  'phone.timeout': 'Telegram has not sent it yet. Tap the button again in a moment.',
  'phone.unsupported': 'Please update Telegram to share your phone number, or open the Edil bot and tap “Share phone number”.',
  'phone.gate': 'Share your phone number to buy tickets and deposit. Withdrawals are not affected.',
  'phone.verified': 'Thank you, your phone number is verified.',
  'bingo.bought_points': "{count} cartela(s) added, paid with Edil Coins.",
  'bingo.points_balance': "You have {points} Edil Coins. 10 ETB of cartelas costs {cost} Edil Coins.",
  'bingo.points_short': "🪙 {points}",
  'gift.eyebrow': "Gift drop",
  'gift.reward': "Each gift",
  'gift.claim': "Claim my gift",
  'gift.won_title': "It is yours!",
  'gift.won_body': "{points} Edil Coins were added to your account. Use them for free tickets.",
  'gift.play': "Play now",
  'gift.starts_in': "Opens in {time}. Stay on this page: it opens by itself.",
  'gift.sold_out': "All the gifts have been claimed. Watch the bot and the group for the next drop!",
  'gift.closed': "Expired",
  'gift.join_to_claim': "Join Edil to claim",
  'gift.verified_only': "For players with a verified phone number.",
  'gift.not_found': "This gift link is not valid.",
  'profile.promotions': "Send me promotions and gifts from Edil",
  'share.win_button': "Share my win",
  'share.win_text': "🎉 I just won {amount} on Edil! Join with my link and try your luck too (21+):",
  'share.failed': "Could not open sharing. Please try again.",
  'auth.telegram_sub': "You sign in with your Telegram account. No password needed.",
  'auth.use_password': "Use phone number and password instead",
  'auth.telegram_failed': "Telegram sign-in did not work. Close Edil and open it again from the bot, or try again in a moment.",
  'auth.telegram_hint_web': "Signed up in Telegram? Use the Telegram button above, or “Forgot password?” to get a password sent to your Telegram.",
  'profile.password_set_title': "Set a password",
  'profile.password_set_text': "In Telegram you are signed in automatically. Set a password to also sign in on edilgames.app with your phone number.",
  'profile.password_change_title': "Password",
  'profile.password_change_text': "For signing in on edilgames.app with your phone number. Changing it signs out your other devices.",
  'profile.password_current': "Current password",
  'tgsignup.welcome': "Welcome, {name}!",
  'tgsignup.sub': "One tap and you are in. Edil uses the phone number on your Telegram account, so it is verified straight away.",
  'tgsignup.confirm': "I am at least {age} years old and accept the terms and the responsible gaming rules",
  'tgsignup.share_join': "Share phone & join",
  'tgsignup.join': "Join Edil",
  'tgsignup.phone_ready': "Phone number from Telegram: {phone}",
  'tgsignup.invited': "Invited with code {code}",
  'tgsignup.have_code': "Have an invite code?",
  'tgsignup.use_bot': "Share in the bot chat instead",
  'tgsignup.bot_hint': "In the bot chat, tap “Share phone number”, then come back here. Sign-up finishes by itself.",
  'rg.footer': 'Play responsibly. 21+ only.',
  'nav.main': "Main",
  'nav.account': "Account menu",
  'nav.section.play': "Play",
  'nav.section.money': "Money",
  'nav.section.account': "Account",
  'status.live': "Live",
  'status.reconnecting': "Reconnecting",
  'common.error_title': "Something went wrong",
  'common.offline_title': "You are offline",
  'lobby.eyebrow': "Timed Pool Raffle",
  'lobby.description': "Pick a room, choose your numbers and watch the draw live.",
  'lobby.next_draw': "Next draw · {room}",
  'lobby.live_pools': "Live prize pools",
  'lobby.my_active': "Your active tickets",
  'lobby.rooms': "Rooms",
  'lobby.per_ticket': "per ticket",
  'lobby.board_of': "Numbers 1–{size}",
  'lobby.sold_short': "sold",
  'lobby.min': "Minimum {min}",
  'lobby.always_draws': "Always draws",
  'lobby.play': "Play",
  'lobby.winners_sub': "Latest settled draws",
  'lobby.no_winners': "No winners yet",
  'room.board': "Number board",
  'room.selected': "Selected",
  'room.your_ticket': "Your ticket",
  'room.cap_left': "{left} of {max} tickets left for you in this round",
  'room.pick_hint': "Tap numbers on the board to add them.",
  'room.pick_short': "Pick numbers",
  'room.selected_count': "{count} selected",
  'room.remove': "Remove #{n}",
  'room.lucky_dip_hint': "We pick free numbers for you",
  'room.lucky_dip_buy': "Lucky dip × {count}",
  'room.lucky_dip_count': "Lucky dip × {count}",
  'room.balance_after_short': "Balance after: {amount}",
  'room.pay': "Pay {amount}",
  'room.tickets': "Tickets",
  'room.price_each': "Price per ticket",
  'room.insufficient': "Your balance is too low for this purchase.",
  'room.next_round': "Next round",
  'room.opens_at': "This round opens for tickets {when}. You can pick numbers then.",
  'room.no_round': "No round is open in this room right now. The next one appears here as soon as it is scheduled.",
  'room.drawing_at': "Draw in",
  'room.history_sub': "Recent rounds in this room",
  'room.schedule': "Schedule",
  'room.board_size': "Numbers",
  'room.minimum': "Minimum tickets",
  'room.per_player': "Tickets per player",
  'room.split': "Prize split (1st · 2nd · 3rd)",
  'round.drawing_sub': "The result was fixed before sales opened and can be verified.",
  'round.private_winner': "Private player",
  'round.winners': "Winners",
  'round.fairness': "Fairness",
  'round.fairness_sub': "Commitment published before the first ticket was sold",
  'round.pool': "Prize pool",
  'round.your_numbers': "Your numbers: {numbers}",
  'tickets.description': "Every ticket you hold, past and present.",
  'tickets.filter': "Filter tickets",
  'tickets.all': "All",
  'tickets.draw': "Draw",
  'tickets.empty_hint': "Buy a ticket in any room and it will appear here.",
  'tickets.browse': "Browse rooms",
  'wallet.description': "Your balance and every movement of money.",
  'wallet.main': "Main balance",
  'wallet.withdraw': "Withdraw",
  'wallet.history_sub': "Most recent first",
  'profile.description': "Your account, security and preferences.",
  'profile.account': "Account",
  'profile.account_text': "How other players see you.",
  'profile.verified': "Verified",
  'profile.unverified': "Not verified",
  'profile.preferences': "Preferences",
  'profile.preferences_text': "Language and privacy.",
  'profile.pin_text': "Needed for withdrawals and changing your payout number.",
  'profile.pin_create': "Set PIN",
  'profile.pin_change': "Change PIN",
  'profile.payout_text': "Withdrawals are sent only to your saved Telebirr number or bank account. You choose which one each time.",
  'profile.payout_save': 'Save',
  'profile.payout_edit': 'Change',
  'profile.payout_remove': 'Remove',
  'profile.payout_bank': 'Bank account',
  'profile.payout_bank_badge': 'Bank',
  'profile.payout_bank_pick': 'Bank',
  'profile.payout_bank_choose': 'Choose your bank',
  'profile.payout_account_number': 'Account number',
  'profile.payout_bank_name': 'Name on the bank account',
  'profile.devices_text': "Sign out devices you no longer use.",
  'profile.active_now': "Active now",
  'verify.eyebrow': "Provably fair",
  'verify.checks': "Independent checks",
  'verify.raw': "Published data",
  'verify.pending_short': "Revealed after the draw",
  'auth.welcome_back': "Welcome back",
  'auth.sign_in_sub': "Sign in with your phone number to play.",
  'auth.back_to_sign_in': "Back to sign in",
  'auth.reset_request_title': "Reset your password",
  'auth.reset_request_sub': "We will send a reset link to the Telegram account linked to your number.",
  'auth.send_reset': "Send reset link",
  'auth.or': "or",
  'auth.browse_rooms': "Browse rooms",
  'auth.create_title': "Create your account",
  'auth.create_sub': "It takes a minute. You must be 21 or older to play.",
  'auth.finish_title': "Finish signing up",
  'auth.finish_sub': "Add your phone number and date of birth to start playing.",
  'auth.dob_hint': "You must be at least {age}.",
  'auth.password_hint': "At least 8 characters. Avoid common passwords.",
  'auth.reset_sub': "Choose a password you have not used before.",
  'auth.save_password': "Save password",
  'auth.sign_in_required': "Sign in to continue",
  'auth.sign_in_required_hint': "Your tickets, wallet and profile are available after signing in.",
  'auth.brand_headline': "Fair draws. Real prizes. Every few minutes.",
  'auth.brand_lead': "Join a room, choose your numbers and watch the draw happen live.",
  'auth.point_fair': "Provably fair",
  'auth.point_fair_text': "Every draw is committed in advance and can be checked by anyone.",
  'auth.point_live': "Live results",
  'auth.point_live_text': "Watch draws as they happen; prizes reach your wallet instantly.",
  'auth.point_payout': "Telebirr payouts",
  'auth.point_payout_text': "Withdraw winnings to your own Telebirr number.",
  'lobby.up_to': 'Up to {amount}',
  'lobby.potential_hint': 'If every number sells',
  'room.prizes_grow': 'Prizes grow with every ticket sold.',
  'room.buy_none': 'Buy tickets',
  'common.not_found': 'Page not found',
  'rg.title': 'Responsible gaming',
  'rg.text': 'Set limits and take breaks. Lowering a limit works at once; raising or removing one takes 24 hours and needs your PIN.',
  'rg.limits': 'Your limits',
  'rg.limits_text': 'Amounts in ETB; session time in minutes. Leave empty for no limit.',
  'rg.kind.DEPOSIT_DAILY': 'Deposits per day',
  'rg.kind.DEPOSIT_WEEKLY': 'Deposits per week',
  'rg.kind.DEPOSIT_MONTHLY': 'Deposits per month',
  'rg.kind.LOSS_DAILY': 'Losses per day',
  'rg.kind.LOSS_WEEKLY': 'Losses per week',
  'rg.kind.LOSS_MONTHLY': 'Losses per month',
  'rg.kind.SPEND_PER_ROUND': 'Spend per round',
  'rg.kind.SESSION_MINUTES': 'Session time (minutes)',
  'rg.no_limit': 'No limit',
  'rg.pending': 'Changes to {value} on {when}',
  'rg.set': 'Save',
  'rg.raise_title': 'Confirm with your PIN',
  'rg.raise_text': 'Raising or removing a limit takes effect in 24 hours.',
  'rg.break': 'Take a break',
  'rg.break_text': 'A break blocks tickets and deposits on every channel. It cannot be ended early. You can still withdraw your balance.',
  'rg.cool_off': 'Cool-off',
  'rg.self_exclusion': 'Self-exclusion',
  'rg.period.24H': '24 hours',
  'rg.period.7D': '7 days',
  'rg.period.30D': '30 days',
  'rg.period.6M': '6 months',
  'rg.period.1Y': '1 year',
  'rg.period.PERMANENT': 'Permanently',
  'rg.confirm_title': 'Start a {kind} for {period}?',
  'rg.confirm_text': 'You will not be able to buy tickets or deposit until it ends, and it cannot be cancelled.',
  'rg.confirm_check': 'I understand this cannot be undone early',
  'rg.start': 'Start break',
  'rg.active': 'Your {kind} is active until {until}. Tickets and deposits are blocked; withdrawals stay available.',
  'rg.active_permanent': 'You have excluded yourself permanently. Tickets and deposits are blocked; withdrawals stay available.',
  'rg.banner': 'You are on a break. Tickets and deposits are blocked; you can still withdraw your balance.',
  'rg.reality_title': 'Time for a check-in',
  'rg.reality_text': 'You have been playing for {minutes} minutes. In this session you staked {staked}; your result is {net}.',
  'rg.keep_playing': 'Keep playing',
  'loyalty.title': "Edil Coins",
  'loyalty.text': "Earn {rate} Edil Coin per ETB you play. Use Edil Coins for free tickets; they never turn into money.",
  'loyalty.points': "{points} Edil Coins",
  'loyalty.expiring': "{points} Edil Coins expire by {when}",
  'loyalty.pay_points': "Use {points} Edil Coins",
  'loyalty.redeemed': "Free tickets added, paid with Edil Coins.",
  'notifications.title': 'Notifications',
  'notifications.description': 'Wins, deposits, withdrawals and account messages.',
  'notifications.empty': 'No notifications yet.',
  'notifications.read_all': 'Mark all as read',
  'notifications.open': 'Notifications',
  'cashier.requests': 'Deposits and withdrawals',
  'cashier.requests_sub': 'Requests in progress and their status',
  'cashier.deposit_title': 'Add money with Telebirr',
  'cashier.deposit_amount_sub': 'Enter how much you want to add. Between {min} and {max}.',
  'cashier.amount': 'Amount (ETB)',
  'cashier.continue': 'Continue',
  'cashier.pay_title': 'Send the money in Telebirr',
  'cashier.pay_sub': 'Send exactly this amount to the account below, then come back to confirm.',
  'cashier.send_to': 'Telebirr number',
  'cashier.holder': 'Account name',
  'cashier.exact_amount': 'Exact amount',
  'cashier.reference': 'Reference',
  'cashier.time_left': 'Time left',
  'cashier.copied': 'Copied',
  'cashier.copy': 'Copy',
  'cashier.step1': 'Open Telebirr and choose “Send money”.',
  'cashier.step2': 'Enter the number above and check the name shows as “{name}”.',
  'cashier.step3': 'Send exactly {amount}. Put {reference} in the reason field if Telebirr allows it.',
  'cashier.step4': 'Keep the confirmation SMS or take a screenshot of the receipt.',
  'cashier.i_paid': 'I have paid',
  'cashier.proof_title': 'Confirm your payment',
  'cashier.proof_sub': 'We check every payment by hand. Usually within {minutes} minutes during {start}–{end}.',
  'cashier.txn_id': 'Telebirr transaction number',
  'cashier.txn_hint': 'From the confirmation SMS, e.g. CJK3ABC12D',
  'cashier.sender_number': 'Number you paid from',
  'cashier.screenshot': 'Screenshot of the receipt',
  'cashier.screenshot_hint': 'JPEG or PNG, up to 5 MB',
  'cashier.choose_screenshot': 'Tap to choose the screenshot',
  'cashier.submit_proof': 'Submit for review',
  'cashier.submitted_title': 'Payment submitted',
  'cashier.submitted_text': 'We will credit your wallet as soon as the payment is checked. You will get a notification.',
  'cashier.done': 'Done',
  'cashier.continue_request': 'Continue',
  'cashier.withdraw_title': 'Withdraw',
  'cashier.withdraw_sub': 'Money is sent only to a payout account saved in your profile.',
  'cashier.withdraw_to': 'Paid to',
  'cashier.withdraw_target': 'Usually paid within {minutes} minutes during {start}–{end}.',
  'cashier.keep_balance': '{keep} always stays in your account.',
  'cashier.deposit_first': 'Make your first deposit to withdraw winnings from the welcome bonus.',
  'cashier.withdraw_limits': 'Between {min} and {max}. Available: {available}.',
  'cashier.pin': 'PIN',
  'cashier.request_withdrawal': 'Request withdrawal',
  'cashier.withdraw_requested': 'Withdrawal requested. The amount is on hold until it is paid.',
  'cashier.no_payout': 'Add a Telebirr number or bank account in your profile before withdrawing.',
  'cashier.no_pin': 'Create a PIN in your profile before withdrawing.',
  'cashier.go_profile': 'Open profile',
  'cashier.cooldown': 'Your payout account changed recently. You can withdraw from {when}.',
  'cashier.playthrough': 'Play with {remaining} more before withdrawing (deposits must be played through once).',
  'cashier.cancel_withdrawal': 'Cancel',
  'cashier.withdrawal_cancelled': 'Withdrawal cancelled. The money is back in your wallet.',
  'cashier.unavailable': 'Deposits and withdrawals are not available in this mode.',
  'cashier.deposit': 'Deposit',
  'cashier.withdrawal': 'Withdrawal',
  'cashier.deposit_approved': 'Your deposit was approved.',
  'cashier.state.AWAITING_PAYMENT': 'Waiting for payment',
  'cashier.state.SUBMITTED': 'In review',
  'cashier.state.NEEDS_INFO': 'Action needed',
  'cashier.state.PENDING_SECOND_APPROVAL': 'In review',
  'cashier.state.APPROVED': 'Approved',
  'cashier.state.REJECTED': 'Not approved',
  'cashier.state.EXPIRED': 'Expired',
  'cashier.state.REQUESTED': 'Requested',
  'cashier.state.PAID': 'Paid',
  'cashier.state.CANCELLED': 'Cancelled',
  'cashier.state.FAILED': 'Failed',
  'cashier.late_ok': 'Paid already? You can still send the proof until {when}.',
  // Fast Bingo
  'bingo.title': 'Fast Bingo',
  'bingo.eyebrow': 'Voice-called · any line wins',
  'bingo.lobby_sub': 'Pick up to 4 cartelas, then listen for the balls. First line wins.',
  'bingo.per_cartela': 'per cartela',
  'bingo.prize': 'Winner gets',
  'bingo.guaranteed': 'Guaranteed · grows as more players join',
  'bingo.guaranteed_from': 'Guaranteed once {n} players join',
  'bingo.prize_grows': 'Grows with every cartela sold',
  'bingo.players': '{players} of {min} players',
  'bingo.players_short': 'players',
  'bingo.joined': '{players} joined · {cartelas} cartelas',
  'bingo.min_players': 'Minimum {min} players',
  'bingo.starts_in': 'Starts in',
  'bingo.waiting': 'Waiting for players',
  'bingo.calling': 'Calling',
  'bingo.state.OPEN': 'Join now',
  'bingo.state.CALLING': 'Playing',
  'bingo.state.SETTLED': 'Finished',
  'bingo.state.REFUNDING': 'Refunding',
  'bingo.state.REFUNDED': 'Refunded',
  'bingo.play_now': 'Play now',
  'bingo.watch_live': 'Watch live',
  'bingo.guaranteed_short': 'Guaranteed prize',
  'bingo.balls_short': '{count} balls',
  'bingo.cartelas_short': '{count} cartelas',
  'bingo.round_info': 'This round',
  'bingo.pick_now': 'Closing soon — pick your cartelas now!',
  'bingo.extended_flash': 'More time added — players are still joining',
  'bingo.play': 'Join',
  'bingo.watch': 'Watch',
  'bingo.pick': 'Pick your cartelas',
  'bingo.pick_hint': 'Tap a number to see its card. Up to {max} per round.',
  'bingo.selected': 'Selected',
  'bingo.your_cartelas': 'Your cartelas',
  'bingo.no_cartelas': 'You have no cartelas in this round.',
  'bingo.buy': 'Buy {count} cartela(s)',
  'bingo.buy_none': 'Pick cartelas',
  'bingo.buy_now': 'Buy {count} · {amount}',
  'bingo.pick_short': 'Tap numbers to pick',
  'bingo.bought': '{count} cartela(s) bought. Good luck!',
  'bingo.confirm_title': 'Buy cartelas',
  'bingo.cartelas': 'Cartelas',
  'bingo.cartela_no': 'Cartela #{n}',
  'bingo.cap_left': '{left} of {max} left this round',
  'bingo.closed': 'This round has started. Next round opens when it ends.',
  'bingo.house_fill_note': 'With {fill}+ players, Edil House fills the empty seats so the game starts on time.',
  'bingo.house_names_note': 'House seats show player names; the verify page lists them.',
  'bingo.house_seats': 'Edil House cartelas',
  'bingo.at_least': 'At least',
  'bingo.guaranteed_min': 'Guaranteed minimum · grows as players join',
  'bingo.today_best': "Today's biggest win: {amount}",
  'bingo.guaranteed_at_close': 'At least {amount} guaranteed at close',
  'bingo.check.house_order': "Edil House's cartelas follow the round's public order",
  'bingo.house_order_note': "It takes free cartelas in an order fixed by the round's public hash.",
  'bingo.extended': 'Not enough players yet: the countdown was extended ({used}/{max}).',
  'bingo.min_note': 'Needs {min} players. If not enough join, every cartela is refunded.',
  'bingo.current_ball': 'Current ball',
  'bingo.calls': '{count} of 75 called',
  'bingo.called_board': 'Called numbers',
  'bingo.get_ready': 'Get ready…',
  'bingo.one_to_go': 'One to go!',
  'bingo.bingo': 'BINGO!',
  'bingo.you_won': 'You won {amount}!',
  'bingo.won_by': 'Cartela #{n} won',
  'bingo.winners': 'Winners',
  'bingo.split': 'Prize split between {count} winners',
  'bingo.house': 'Edil House',
  'bingo.private_winner': 'A player',
  'bingo.next_round': 'Next round',
  'bingo.refunded': 'Not enough players joined, so every cartela was refunded.',
  'bingo.rules': 'How it works',
  'bingo.rule_1': 'Pick up to {max} cartelas before the countdown ends. Each costs {price}.',
  'bingo.rule_2': 'A ball is called every {seconds} seconds. Your cards are marked automatically.',
  'bingo.rule_3': 'The first card to complete any row, column or diagonal wins. Ties split the prize.',
  'bingo.rule_4': 'The winner gets {share}% of the pool; the house keeps {house}%.',
  'bingo.rule_5': 'Needs {min} players. Short rounds wait a little longer, then refund.',
  'bingo.verify': 'Verify this game',
  'bingo.recent': 'Recent games',
  'bingo.pages': 'Cartela numbers',
  'room.pages': 'Numbers',
  'bingo.go_to': 'Go to cartela #',
  'bingo.go': 'Go',
  'bingo.recent_sub': 'Tap a game to see its balls and check it was fair.',
  'bingo.history_meta': '{players} players · won on ball {balls}',
  'bingo.history_meta_one': '1 player · won on ball {balls}',
  'bingo.verify_title': 'Verify a bingo game',
  'bingo.verify_sub': 'The call order comes from a secret seed whose fingerprint was published before sales opened.',
  'bingo.verify_ok': 'Every check passed: this game was fair.',
  'bingo.verify_bad': 'A check failed. Please message our support team: @EdilGamesSupport',
  'bingo.check.commit': 'Seed matches the published fingerprint',
  'bingo.check.tickets': 'Sold cartelas match the hash stored at close',
  'bingo.check.calls': 'Called balls follow the seed’s order',
  'bingo.check.winners': 'Winners are exactly the first cards to complete a line',
  'bingo.sound_on': 'Tap for sound',
  'bingo.sound_off': 'Mute caller',
  'bingo.sound_unmute': 'Unmute caller',
  'bingo.voice': 'Caller voice',
  'bingo.unavailable': 'Bingo is not available right now.',
  'bingo.no_round': 'The next round opens in a moment.',
} as const;

export type MessageKey = keyof typeof en;
